import PermissionsBase from '@linc-technologies/linced-common/helpers/permissions-base';

export default class PermissionsMeet extends PermissionsBase {
  compute([level]) {
    return this.permissions.meet(level);
  }
}
